<template>
  <div>
    <!-- Welcome to OBCM -->
    <div class="position-relative">
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-dark shape-skew">
          <img
            src="img/sections/bible-landing.jpg"
            style="width: 100vw"
            class="d-none d-lg-block"
          />
          <img
            src="img/sections/bible-landing.jpg"
            style="height: 100%"
            class="d-block d-lg-none"
          />
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3 text-white">
                  <span>Welcome to</span> One Body Christian Ministries
                </h1>
                <p class="lead text-white">
                  We are a Southern Baptist church committed to love one another, making
                  disciples of Jesus Christ, and planting new churches to spread the
                  Gospel for the glory of God alone.
                </p>
                <div class="btn-wrapper">
                  <a href="/what-we-teach">
                    <base-button class="mb-3 mb-sm-0" type="primary">
                      Learn More
                    </base-button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>

    <!-- Who We Are, Ministries, Our Leaders -->
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <img
                    v-lazy="'img/sections/what-we-teach.jpg'"
                    alt="Rounded image"
                    class="img-fluid rounded shadow mb-4"
                  />
                  <h6 class="text-primary text-uppercase">What We Teach</h6>
                  <p class="description mt-3">
                    Our teachings align with the Baptist Faith and Message 2000 and the
                    distinctives of Acts 29.
                  </p>
                  <a href="/what-we-teach">
                    <base-button type="outline-primary" class="mt-4"
                      >Learn more</base-button
                    >
                  </a>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <img
                    v-lazy="'img/sections/our-ministries.jpg'"
                    alt="Rounded image"
                    class="img-fluid rounded shadow mb-4"
                  />
                  <h6 class="text-primary text-uppercase">Our Ministries</h6>
                  <p class="description mt-3">
                    Our ministries are driven by spiritual gifts, centered on the gospel
                    of Christ, and devoted to God's glory.
                  </p>
                  <a href="/our-ministries">
                    <base-button type="outline-primary" class="mt-4"
                      >Learn more</base-button
                    >
                  </a>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <img
                    v-lazy="'img/sections/our-leaders.jpg'"
                    alt="Rounded image"
                    class="img-fluid rounded shadow mb-4"
                  />
                  <h6 class="text-primary text-uppercase">Our Leaders</h6>
                  <p class="description mt-3">
                    Our pastors serve as undershepherds, guiding us under the leadership
                    of Jesus Christ, the Great Good Shepherd.
                  </p>
                  <a href="/our-leaders">
                    <base-button type="outline-primary" class="mt-4"
                      >Learn more</base-button
                    >
                  </a>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- You can find us here -->
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center px-4">
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <h4>We gather every Sunday at <b>9AM</b>.</h4>
              <hr />
              <p class="lead mt-3">You can find us here at</p>
              <a :href="gmapLink">
                <icon name="ni ni-square-pin" type="primary" rounded />
                <p class="lead">
                  2224 Tejeron St, Santa Ana, Manila, Metro Manila, Philippines, 1009
                </p>
              </a>
            </div>
          </div>
          <div class="col-md-6 order-md-2">
            <a :href="gmapLink"
              ><img src="img/sections/gmap-loc.jpg" class="img-fluid floating"
            /></a>
          </div>
          <div class="col-md-12 order-md-3">
            <a href="/#contact-us">
              <base-button type="primary" class="mt-4">Contact Us</base-button>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Our Leaders -->
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-dark">
        <img
          src="img/sections/obcm-pastors.jpg"
          style="width: 100vw"
          class="d-none d-lg-block"
        />
        <img
          src="img/sections/obcm-pastors.jpg"
          style="height: 100%"
          class="d-block d-lg-none"
        />
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-5"></div>
          </div>
          <div class="col-lg-8 order-lg-1">
            <div class="d-flex px-3">
              <div class="pl-4">
                <h4 class="display-3 text-white">Our Leaders</h4>
                <p class="text-white lead">
                  Our church is blessed with faithful pastors who lead us with
                  willingness, eagerness, and humility. Take a moment to get to know our
                  current OBCM Sta. Ana pastors and their key areas of service.
                </p>
                <div class="btn-wrapper">
                  <a href="/our-leaders">
                    <base-button class="mb-3 mb-sm-0" type="primary">
                      Learn More
                    </base-button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-4 mt-2 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="/our-leaders#ptr-uziel">
                <img
                  v-lazy="'img/pastors/ptr-uziel.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 200px"
                />
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">Ptr. Uziel Idurot</span>
                    <small class="caption text-muted">Lead Pastor</small>
                  </h5>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mt-2 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="/our-leaders#ptr-lyndon">
                <img
                  v-lazy="'img/pastors/ptr-lyndon.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 200px"
                />
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">Ptr. Lyndon Nabua</span>
                    <small class="caption text-muted">Pastor</small>
                  </h5>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mt-2 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="/our-leaders#ptr-joel">
                <img
                  v-lazy="'img/pastors/ptr-joel.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 200px"
                />
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">Ptr. Joel Idurot</span>
                    <small class="caption text-muted">Pastor Emeritus</small>
                  </h5>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mt-2 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="/our-leaders#ptr-roel">
                <img
                  v-lazy="'img/pastors/ptr-roel.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 200px"
                />
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">Ptr. Roel Rumawak</span>
                    <small class="caption text-muted">Pastor</small>
                  </h5>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mt-2 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="/our-leaders#ptr-arvick">
                <img
                  v-lazy="'img/pastors/ptr-arvick.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 200px"
                />
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">Ptr. Arvick Mirondo</span>
                    <small class="caption text-muted">Pastor</small>
                  </h5>
                </div>
              </a>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 mt-2 mb-5 mb-lg-0">
            <div class="px-4">
              <a href="/our-leaders#ptr-rm">
                <img
                  v-lazy="'img/pastors/ptr-rm.png'"
                  class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                  style="width: 200px"
                />
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">Ptr. RM Rodriguez</span>
                    <small class="caption text-muted">Pastor</small>
                  </h5>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      gmapLink: "https://maps.app.goo.gl/qnaCZsdgxYTUExB8A",
    };
  },
};
</script>

<style scoped>
.ministry-description {
  font-style: italic;
}
</style>
